import React from "react";
import { CiLinkedin } from "react-icons/ci";
import { FaYoutube } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaTelegram } from "react-icons/fa";
import { NavLink } from "react-router-dom";

import Scroll from "./Scroll";
import "../Css/Footer.css";

function Footer() {
  return (
    <div id="mainfot">
      <div id="scr" className="container-fluid" style={{ position: "fixed" }}>
        <Scroll />
      </div>
  <div className="container-fluid">
    <div className="row fotrow">
 
      <div className="col-xl-2">
        <div id="media">
          <NavLink to="https://in.linkedin.com/in/montu-kharb-92b67b240">
            <i id="link1">
              <CiLinkedin />
            </i>
          </NavLink>
          <NavLink to="https://www.youtube.com/channel/UCEXVE4J_OgxeZvNF60DbRIg">
            <i id="link2">
              {" "}
              <FaYoutube />{" "}
            </i>
          </NavLink>
          <NavLink to="https://www.facebook.com/profile.php?id=100089109543795">
            {" "}
            <i id="link3">
              {" "}
              <FaFacebook />{" "}
            </i>
          </NavLink>
          <NavLink to="https://www.instagram.com/montu_kharb/">
            {" "}
            <i id="link4">
              {" "}
              <FaInstagram />{" "}
            </i>
          </NavLink>
          <NavLink to="https://github.com/Montukharb">
            {" "}
            <i id="link5">
              {" "}
              <FaGithub />{" "}
            </i>
          </NavLink>
          <NavLink to="#">
            {" "}
            <i id="link6">
              {" "}
              <FaTwitter />{" "}
            </i>
          </NavLink>
          <NavLink to="#">
            {" "}
            <i id="link7">
              {" "}
              <FaTelegram />{" "}
            </i>
          </NavLink>
        </div>
      </div>

      <div className="col-xl-5 fotcol">
        <h6>
          Web Information Manager: Mr.Montu kharb| Contact No :8059202360 , |
          Last updated on : Apr 25 2023 10:39:30:970P{" "}
        </h6>
      </div>
      <div className="col-xl-2" title="sign-up">
        {" "}
        <NavLink to="/contact" id="touchlink">
          Get In Touch{" "}
        </NavLink>
      </div>
     
      </div>
     </div>
     <div id="freespace">

     </div>
     <div className="container-fluid">

     <div className="row" id="text2">
       <p>
         Copyright &#169; 2023.All rights reserved &#174;. Devloped By :
        <i id="special">Montukharb &#8482;</i>
        </p>
     </div>

     </div>
    </div>
  );
}
export default Footer;
